import React, { useEffect, useState } from "react";
import { Col, Row, Form } from "react-bootstrap";
import { getSessionId } from "../../../utils/tokenHandlers";
import { getNatureOfBusiness } from "../../../feature/apis/listOfValues/getNatureOfBusiness";

interface NatureOfBusinessProps {
  name: string;
  label: string;
  register: any;
  required?: boolean;
  requiredMessage?: string;
  handleChange?: () => JSX.Element;
  defaultValue?: string;
  error?: string;
  disabled?: boolean;
  colored?: boolean;
}

interface NatureOfBusinessData {
  sr_no: number;
  lov_type: string;
  lov_display_value: string;
  lov_value: string;
  is_active: boolean;
}

const NatureOfBusiness: React.FC<NatureOfBusinessProps> = ({
  name,
  label,
  register,
  required,
  requiredMessage = "This field is required",
  handleChange,
  defaultValue,
  disabled,
  error,
  colored = false,
}) => {
  const token = getSessionId();

  const [natureOfBusinessValues, setNatureOfBusinessValues] = useState<
    NatureOfBusinessData[]
  >([]);

  useEffect(() => {
    getNatureOfBusiness(token).then((response) => {
      //// console.log("REGISTER WITH --> ", response);
      setNatureOfBusinessValues(response.result.result);
    });
  }, []);

  return (
    <Form.Group as={Col} className="mb-3">
      <Row className="align-items-center">
        <Form.Label column md={4}>
          <span className="float-end">
            {label}{" "}
            <span className="text-danger form-label">
              {required ? "*" : ""}
            </span>{" "}
            :
          </span>
        </Form.Label>
        <Col md={8}>
          <Form.Select
            as="select"
            className={`custom-input form-control ${error ? "is-invalid" : ""}`}
            onChange={handleChange}
            {...register(name, {
              required: required ? requiredMessage : false,
            })}
            value={defaultValue}
            disabled={disabled}
            style={{ backgroundColor: colored ? "#C2FFC7" : "" }} // Apply color conditionally
          >
            <option value="">Select Option</option>
            {natureOfBusinessValues.map((natureOfBusinessValue, index) => (
              <option key={index} value={natureOfBusinessValue.lov_value}>
                {natureOfBusinessValue.lov_display_value}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Col md={4}></Col>
        <Col md={8}>{error && <p className="m-0 err-msg">{error}</p>}</Col>
      </Row>
    </Form.Group>
  );
};

export default NatureOfBusiness;
